import React from 'react';
import Reactable from 'reactable';
import TableCell from '../../../../common/TableCell';
import { mapTableColumns } from '../helpers';
import * as shapes from '../shapes';


const Tr = Reactable.Tr;
const Td = Reactable.Td;
const Item = ({ item }) => {
  const columns = mapTableColumns(item);

  return (
    <Tr
      className="c-table-card__row c-table-card__row--clickable"
      key={item.barberId}
    >
      { columns.map(column => (
        <Td
          className="c-table-card__cell"
          column={column}
          key={column}
          value={item[column]}
        >
          <TableCell column={column}>
            {item[column]}
          </TableCell>
        </Td>
      )) }
    </Tr>
  );
};
Item.propTypes = {
  item: shapes.commissionSplitItem.isRequired,
};

export default Item;
